export const siteInfo = {
  name: "看瓜爆料",
  slogan: "今日速递，新鲜瓜料随时刷",
  domain: "https://tig-mes.cn",
  description:
    "看瓜爆料最新实时更新，今日热点瓜料、新鲜爆料速递不停歇，随时刷新随时有料。",
  contactEmail: "hello@kanguabaoliao.com",
  prEmail: "pr@kanguabaoliao.com",
};

export const categories = [
  {
    slug: "mingxing",
    name: "明星八卦",
    icon: "ri-star-smile-line",
    desc: "台前幕后的一手动向，恋情、行程与合作的实时进展。",
  },
  {
    slug: "neimu",
    name: "娱乐内幕",
    icon: "ri-spy-line",
    desc: "行业内部视角，项目变动、团队调整背后的真实原因。",
  },
  {
    slug: "zongyi",
    name: "综艺热议",
    icon: "ri-live-line",
    desc: "热门综艺的名场面、剪辑争议与播出后的舆论走向。",
  },
  {
    slug: "wanghong",
    name: "网红动态",
    icon: "ri-signal-tower-line",
    desc: "直播间与短视频平台上的话题人物近期动作合集。",
  },
  {
    slug: "yingshi",
    name: "影视舆情",
    icon: "ri-film-line",
    desc: "新片新剧的口碑曲线、票房走势与观众讨论焦点。",
  },
  {
    slug: "shishang",
    name: "时尚热点",
    icon: "ri-vip-diamond-line",
    desc: "红毯造型、品牌合作与穿搭话题的集中盘点。",
  },
];

export const tickerHeadlines = [
  "顶流男星恋情时间线被整理成表格，双方工作室凌晨先后回应",
  "爆款综艺录制现场疑似起争执，节目组三小时后发说明",
  "某热播剧大结局口碑回升，评分一夜之间上涨零点四分",
  "头部主播复播首场数据公布，在线人数峰值破三百万",
  "红毯同款礼服撞衫上热搜，造型团队连夜发长文解释",
  "两部待播剧同时改档，片方给出的理由几乎一模一样",
  "音乐节现场突降暴雨，主办方临时调整舞台顺序引热议",
  "某男团成员被拍到深夜聚餐，经纪公司回应仅一句话",
];

export const articles = [
  {
    id: "g-001",
    slug: "dingliu-nanxing-lianqing-shijianxian-huifu",
    title: "顶流男星恋情时间线被整理成表格，双方工作室凌晨先后回应",
    category: "明星八卦",
    categorySlug: "mingxing",
    summary:
      "一份按日期排列的行程对照表在网络流传，把近半年的公开活动与私下行程放在一起比对，凌晨两点前后，双方工作室几乎同时给出回应。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20empty%20theatre%20stage%20under%20a%20single%20red%20spotlight%20with%20deep%20crimson%20and%20warm%20amber%20tones%2C%20soft%20haze%20in%20the%20air%2C%20cinematic%20editorial%20abstract%20background%2C%20high%20contrast%2C%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%20with%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-01&orientation=landscape",
    author: "瓜田观察员",
    publishedAt: "2026-09-10T09:12:00+08:00",
    timeLabel: "12 分钟前",
    views: 182340,
    comments: 3421,
    tags: ["恋情进展", "工作室回应", "行程比对"],
    hot: true,
    rank: 1,
    content: [
      "从昨晚开始，一份被网友称为「时间线表格」的整理文档在多个社交平台快速流转。表格以周为单位，把近半年来公开露面的行程与部分被拍到的私人活动并列排布，试图说明两人之间可能存在长期交集。需要说明的是，这些内容均来自网友整理与公开路透，并无实质性的官方佐证。",
      "凌晨两点前后，双方工作室几乎在同一时间发布了回应。措辞都相当克制，一方强调「艺人私人生活不便展开」，另一方则表示「请把注意力放回作品」。两条回应在半小时内先后登上热搜，讨论量迅速突破百万。",
      "值得注意的是，回应发布后，原本流传的表格文档被大量删除，但截图仍在扩散。有长期关注此事的网友指出，表格中至少有四处日期与实际公开行程对不上，这也成为评论区争论最激烈的部分。",
      "截至发稿，双方均未再追加说明。我们会持续跟进事件后续，一旦有新的官方信息，会在「今日速递」第一时间更新。",
    ],
  },
  {
    id: "g-002",
    slug: "baokuan-zongyi-luzhi-xianchang-zhengyi",
    title: "爆款综艺录制现场疑似起争执，节目组三小时后发说明",
    category: "综艺热议",
    categorySlug: "zongyi",
    summary:
      "一段模糊的场外视频在深夜流出，画面中有人抬高了音量。录制结束三小时后，节目组发布了一份不足两百字的说明。",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20studio%20microphone%20in%20front%20of%20a%20blurred%20dark%20backdrop%20with%20warm%20gold%20rim%20light%20and%20hints%20of%20deep%20crimson%2C%20cinematic%20editorial%20abstract%20photography%2C%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain%20and%20elegant%20negative%20space&width=1200&height=800&seq=guwa-cover-02&orientation=landscape",
    author: "综艺雷达",
    publishedAt: "2026-09-10T08:05:00+08:00",
    timeLabel: "1 小时前",
    views: 96420,
    comments: 1876,
    tags: ["录制现场", "节目组声明", "剪辑争议"],
    hot: true,
    rank: 2,
    content: [
      "这段视频只有二十七秒，画质相当模糊，能分辨出的信息有限，但其中一句被反复播放的对话片段，成了整晚讨论的起点。视频发布者称拍摄于某综艺的晚间录制时段，但并未提供更多背景。",
      "录制结束大约三小时后，节目组通过官方账号发布说明，确认当晚「因流程安排产生过短暂沟通」，并强调不影响后续录制进度。说明中没有提及任何嘉宾姓名，也没有回应视频本身的真实性。",
      "有意思的是，说明发布后，讨论的方向迅速从「现场发生了什么」转向「剪辑会怎么处理」。不少观众翻出该节目往季的剪辑手法，认为这段内容大概率不会出现在正片里。",
      "目前该期节目尚未公布播出时间。我们会继续关注后续是否会有更多信息释出。",
    ],
  },
  {
    id: "g-003",
    slug: "reboyju-dajieju-koubei-huizhang",
    title: "某热播剧大结局口碑回升，评分一夜之间上涨零点四分",
    category: "影视舆情",
    categorySlug: "yingshi",
    summary:
      "开播时被吐槽节奏拖沓，收官当晚却因为最后两集的收束方式迎来一波集中好评，评分曲线走出了少见的V形。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20vintage%20cinema%20seats%20lit%20by%20warm%20amber%20light%20fading%20into%20deep%20crimson%20shadows%2C%20cinematic%20editorial%20abstract%20photography%2C%20nostalgic%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain%20and%20soft%20depth%20of%20field&width=1200&height=800&seq=guwa-cover-03&orientation=landscape",
    author: "剧集观察",
    publishedAt: "2026-09-10T07:20:00+08:00",
    timeLabel: "2 小时前",
    views: 74150,
    comments: 1204,
    tags: ["大结局", "评分回升", "口碑反转"],
    hot: true,
    rank: 3,
    content: [
      "这部剧开播首周的评分一度跌到及格线附近，前六集被大量观众评价为「信息量太少」。但从第十二集开始，叙事节奏明显加快，支线人物也陆续收拢。",
      "收官当晚，最后两集把此前埋下的三个伏笔一次性兑现，弹幕和评论区几乎被「原来如此」刷屏。截至今天早上，该剧评分较开播时上涨了零点四分，短评区新增评价超过两万条。",
      "也有观众持保留态度，认为前期的拖沓无法被结局完全抵消。但从数据层面看，这部剧的完播率在最后一周出现了明显反弹，说明仍有相当一部分观众坚持看到了最后。",
    ],
  },
  {
    id: "g-004",
    slug: "toubu-zhubo-fubo-shouzhang-shuju",
    title: "头部主播复播首场数据公布，在线人数峰值破三百万",
    category: "网红动态",
    categorySlug: "wanghong",
    summary:
      "停播近两个月后回归，首场直播没有做大型活动，靠一场纯聊天把在线人数推到了三百万以上。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20glowing%20ring%20light%20against%20a%20deep%20charcoal%20background%20with%20warm%20golden%20glow%20and%20a%20touch%20of%20crimson%2C%20cinematic%20editorial%20abstract%20photography%2C%20modern%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%20with%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-04&orientation=landscape",
    author: "直播风向标",
    publishedAt: "2026-09-10T06:40:00+08:00",
    timeLabel: "3 小时前",
    views: 62880,
    comments: 998,
    tags: ["复播", "在线人数", "直播间"],
    hot: true,
    rank: 4,
    content: [
      "这场直播的预告只在开播前两小时发布，没有预热海报，也没有嘉宾名单。开播十分钟后，在线人数冲到一百二十万，半小时后突破三百万峰值。",
      "整场直播以聊天为主，主播用了大段时间回应停播期间的各种传闻，但基本停留在「感谢大家等我」这类表述，没有展开细节。有老观众在弹幕里表示，这种克制反而是最合理的处理方式。",
      "数据层面值得一提的是，本场的平均停留时长比停播前高出近四成，说明回归首场吸引的多是长期关注的老观众，而非临时涌入的流量。",
    ],
  },
  {
    id: "g-005",
    slug: "hongtan-zhuangshan-tongkuan-reyi",
    title: "红毯同款礼服撞衫上热搜，造型团队连夜发长文解释",
    category: "时尚热点",
    categorySlug: "shishang",
    summary:
      "两位艺人先后走上同一条红毯，礼服来自同一品牌同一季，撞衫话题在十分钟内冲上热搜前列。",
    cover:
      "https://readdy.ai/api/search-image?query=Flowing%20crimson%20silk%20fabric%20draped%20over%20a%20dark%20marble%20surface%20with%20warm%20amber%20light%20grazing%20the%20folds%2C%20cinematic%20editorial%20fashion%20abstract%20photography%2C%20elegant%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-05&orientation=landscape",
    author: "时装档案",
    publishedAt: "2026-09-10T00:15:00+08:00",
    timeLabel: "9 小时前",
    views: 54300,
    comments: 762,
    tags: ["红毯", "撞衫", "造型"],
    hot: false,
    rank: 5,
    content: [
      "两套礼服的版型差异其实不小，一套是收腰长摆，另一套做了不对称剪裁，但配色与面料过于接近，高清生图出来之后，视觉上的相似度被进一步放大。",
      "话题发酵后，其中一方的造型团队连夜发布长文，说明礼服是提前三个月向品牌方确认的，并附上了一部分沟通记录截图。另一方暂未回应。",
      "品牌方面在当天中午更新了社交账号，把两套造型分别转发，配文使用了「不同演绎」的措辞。这条动态被不少网友认为是品牌方在主动降温。",
    ],
  },
  {
    id: "g-006",
    slug: "liangbu-daibo-jv-tongshi-gaidang",
    title: "两部待播剧同时改档，片方给出的理由几乎一模一样",
    category: "娱乐内幕",
    categorySlug: "neimu",
    summary:
      "上午十点和下午两点，两部原本错开档期的剧集先后宣布调整上线时间，两份公告的核心表述高度相似。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20clock%20face%20dissolving%20into%20warm%20amber%20and%20deep%20crimson%20smoke%20on%20a%20dark%20backdrop%2C%20cinematic%20editorial%20abstract%20photography%2C%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain%20and%20elegant%20negative%20space&width=1200&height=800&seq=guwa-cover-06&orientation=landscape",
    author: "业内线人",
    publishedAt: "2026-09-09T22:30:00+08:00",
    timeLabel: "昨天 22:30",
    views: 41200,
    comments: 531,
    tags: ["改档", "排播", "片方公告"],
    hot: false,
    rank: 6,
    content: [
      "从时间节点看，两部剧的新档期恰好隔开了两周，这意味着原本可能撞车的排播被重新错开。多位从业者在社交平台上表示，这种量级的调整通常不是单方面能决定的。",
      "两份公告都用了「为了呈现更好的效果」这一类表述，甚至连标点习惯都相近。有细心的网友把两份公告并排对比，发帖称「像同一个模板」的截图获得了大量转发。",
      "业内普遍的看法是，这次调整与平台整体的排播策略有关，而非剧集本身的质量问题。真正的验证点会落在调整后的首周数据上。",
    ],
  },
  {
    id: "g-007",
    slug: "yinyuejie-baoyu-wutai-tiaozheng",
    title: "音乐节现场突降暴雨，主办方临时调整舞台顺序引热议",
    category: "娱乐内幕",
    categorySlug: "neimu",
    summary:
      "傍晚的一场暴雨打乱了整晚的演出安排，两小时的等待让现场观众的情绪几度起伏。",
    cover:
      "https://readdy.ai/api/search-image?query=Rain%20falling%20through%20amber%20stage%20light%20against%20a%20deep%20crimson%20night%20backdrop%20with%20soft%20haze%2C%20cinematic%20editorial%20abstract%20photography%2C%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain%20and%20dramatic%20contrast&width=1200&height=800&seq=guwa-cover-07&orientation=landscape",
    author: "现场记录",
    publishedAt: "2026-09-09T20:10:00+08:00",
    timeLabel: "昨天 20:10",
    views: 38600,
    comments: 488,
    tags: ["音乐节", "演出调整", "现场"],
    hot: false,
    rank: 7,
    content: [
      "暴雨来得比预报早了将近四十分钟，当时正好是第三组艺人即将上台的时间点。舞台设备的防水处理花了不少时间，演出因此中断了约两个小时。",
      "主办方在中断期间连续三次通过现场广播更新进度，并在社交账号同步说明。恢复演出后，主办方把两组合唱环节压缩成了串烧，以保证压轴艺人能按时登场。",
      "现场观众的反应两极：一部分人对长时间等待表达了不满，另一部分人则认为在安全前提下完成整场演出已属不易。相关话题在当晚登上了本地热搜。",
    ],
  },
  {
    id: "g-008",
    slug: "nantuan-chengyuan-shenye-jucan-huiying",
    title: "某男团成员被拍到深夜聚餐，经纪公司回应仅一句话",
    category: "明星八卦",
    categorySlug: "mingxing",
    summary:
      "凌晨流出的几张餐厅门口照片，让一段「行程外时间」的讨论延续了整整一个白天。",
    cover:
      "https://readdy.ai/api/search-image?query=Rain%20slick%20city%20street%20at%20night%20with%20warm%20amber%20street%20lamps%20and%20deep%20crimson%20neon%20reflections%2C%20cinematic%20editorial%20abstract%20photography%2C%20moody%20urban%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-08&orientation=landscape",
    author: "瓜田观察员",
    publishedAt: "2026-09-09T18:45:00+08:00",
    timeLabel: "昨天 18:45",
    views: 35400,
    comments: 612,
    tags: ["聚餐路透", "经纪公司", "回应"],
    hot: false,
    rank: 8,
    content: [
      "照片拍摄于凌晨，光线较差，能辨认的信息主要来自餐厅招牌与随行人数。发布者称拍摄地点在市中心某商圈，但并未说明同行者的身份。",
      "当天下午，经纪公司通过简短声明回应，仅一句「属于正常朋友聚会，感谢关心」，没有提供更多细节，也没有对照片来源作出说明。",
      "粉丝群体的反应相对平静，多数讨论集中在「希望不要过度解读」。也有网友指出，这类路透近年越来越频繁，艺人与团队的处理方式正在变得更简洁。",
    ],
  },
  {
    id: "g-009",
    slug: "sanwei-zhubo-lianmai-yinfa-taolun",
    title: "三位主播连麦后话题反转，评论区从质疑转向理解",
    category: "网红动态",
    categorySlug: "wanghong",
    summary:
      "一场计划外的三人连麦，把持续了半个月的争议在一个晚上讲清楚了大半。",
    cover:
      "https://readdy.ai/api/search-image?query=Three%20abstract%20glowing%20audio%20waveform%20arcs%20crossing%20on%20a%20dark%20charcoal%20background%20with%20warm%20amber%20and%20crimson%20gradients%2C%20cinematic%20editorial%20abstract%20photography%2C%20modern%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-09&orientation=landscape",
    author: "直播风向标",
    publishedAt: "2026-09-09T15:20:00+08:00",
    timeLabel: "昨天 15:20",
    views: 29800,
    comments: 405,
    tags: ["连麦", "争议回应", "舆情反转"],
    hot: false,
    rank: 9,
    content: [
      "这场连麦原本只是一次普通的联动，但在其中一位主播提到近期的分成争议后，另外两人先后加入讨论，话题逐渐深入到合作模式本身。",
      "三人各自说明了此前的沟通记录，也承认在信息传达上存在延迟。直播结束后，相关话题的负面评价比例明显下降，评论区出现了大量「原来是没沟通清楚」的表述。",
      "有分析者认为，这次反转的关键在于当事人选择了同步沟通，而非各自发布声明。这种处理方式在过去一年里正变得越来越常见。",
    ],
  },
  {
    id: "g-010",
    slug: "xuanxiu-jv-mianhaishi-jianji-zaoyi",
    title: "某悬疑剧出现明显剪辑断层，观众逐帧列出四处衔接问题",
    category: "影视舆情",
    categorySlug: "yingshi",
    summary:
      "第七集播出后，一条逐帧对比的帖子里列出了四处时间线跳跃，讨论迅速从剧情转向制作流程。",
    cover:
      "https://readdy.ai/api/search-image?query=Cracked%20mirror%20fragments%20reflecting%20warm%20amber%20light%20against%20a%20deep%20crimson%20shadowed%20background%2C%20cinematic%20editorial%20abstract%20photography%2C%20moody%20mysterious%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-10&orientation=landscape",
    author: "剧集观察",
    publishedAt: "2026-09-09T11:05:00+08:00",
    timeLabel: "昨天 11:05",
    views: 26300,
    comments: 318,
    tags: ["剪辑争议", "悬疑剧", "时间线"],
    hot: false,
    rank: 10,
    content: [
      "被讨论最多的是一段长达四十秒的转场，画面从白天直接跳到深夜，中间缺少必要的过渡镜头。发帖者用逐帧截图的方式，把这段与前后两集的同类转场进行了对比。",
      "制作方目前尚未回应。有参与过同类项目的从业者表示，这种长度的断层更可能出现在后期调整阶段，而非拍摄本身的问题。",
      "无论原因如何，这一集的口碑出现了小幅回落，而前一集刚刚创下开播以来的最高评分。观众对细节的敏感度，正在成为影响剧集口碑的重要变量。",
    ],
  },
  {
    id: "g-011",
    slug: "pinpai-dazhan-shishang-zhou-pandian",
    title: "本周时尚事件盘点：三家品牌在同一天更新代言阵容",
    category: "时尚热点",
    categorySlug: "shishang",
    summary:
      "一天之内连续三条官宣，让原本平淡的周中变得格外热闹，也让人看到了品牌节奏的微妙变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20geometric%20silk%20bands%20in%20accent%20green%20and%20crimson%20intertwining%20on%20a%20warm%20cream%20surface%20with%20soft%20amber%20light%2C%20cinematic%20editorial%20abstract%20photography%2C%20refined%20minimal%20atmosphere%2C%20no%20people%2C%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-11&orientation=landscape",
    author: "时装档案",
    publishedAt: "2026-09-08T19:30:00+08:00",
    timeLabel: "9 月 8 日",
    views: 22800,
    comments: 244,
    tags: ["品牌代言", "时尚盘点", "官宣"],
    hot: false,
    rank: 11,
    content: [
      "三条官宣分别集中在上午十点、下午三点和晚上八点，时间安排得相当规整。从代言人类型来看，三家品牌这一次都选择了近两年上升势头明显的新生代面孔。",
      "有品牌公关从业者在社交平台分析，这种集中官宣并非巧合，而更可能与换季节点和接下来的大型活动档期有关。",
      "值得留意的是，三家品牌在海报视觉上不约而同采用了暖色调，这在过去两年的同类物料中并不常见，或许预示着接下来一段时间的视觉走向。",
    ],
  },
  {
    id: "g-012",
    slug: "zongyi-jianji-fengbo-hou-pian-chang",
    title: "综艺剪辑风波后正片加长十五分钟，观众态度开始松动",
    category: "综艺热议",
    categorySlug: "zongyi",
    summary:
      "在争议持续了一周之后，节目组用一次加长播出作为回应，效果比预想中要好。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20editing%20timeline%20strip%20glowing%20with%20warm%20amber%20light%20frames%20against%20a%20dark%20crimson%20background%2C%20cinematic%20editorial%20abstract%20photography%2C%20modern%20moody%20atmosphere%2C%20no%20people%2C%20refined%20magazine%20cover%20aesthetic%2C%20subtle%20film%20grain&width=1200&height=800&seq=guwa-cover-12&orientation=landscape",
    author: "综艺雷达",
    publishedAt: "2026-09-08T14:10:00+08:00",
    timeLabel: "9 月 8 日",
    views: 19700,
    comments: 206,
    tags: ["加长版", "剪辑回应", "正片"],
    hot: false,
    rank: 12,
    content: [
      "加长版比常规播出多了十五分钟，主要在第二段任务环节补充了大量未被剪入的互动，其中几处正是此前争议中被认为「缺失」的部分。",
      "节目组没有发布正式说明，只是在上线时更新了一条简短的动态，配文为「把完整的还给大家」。这一处理方式获得了不少正面评价。",
      "从舆情曲线看，加长版上线当天，相关话题的负面情绪占比下降了接近三成。内容本身的补足，似乎比任何解释都更有效。",
    ],
  },
];

export const hotTopics = [
  { label: "顶流恋情时间线", keyword: "恋情进展", heat: 98, trend: "up" },
  { label: "综艺现场争执", keyword: "节目组回应", heat: 91, trend: "up" },
  { label: "热播剧大结局", keyword: "评分回升", heat: 87, trend: "down" },
  { label: "头部主播复播", keyword: "在线破三百万", heat: 82, trend: "up" },
  { label: "红毯撞衫事件", keyword: "造型团队回应", heat: 76, trend: "flat" },
  { label: "两部待播剧改档", keyword: "排播调整", heat: 68, trend: "down" },
];

export const faqs = [
  {
    q: "看瓜爆料的内容多久更新一次？",
    a: "「今日速递」栏目在热点集中时段保持高频更新，通常每 10 到 30 分钟滚动一次。遇到重大事件发酵时，会临时提高更新频率，保证你第一时间看到进展。",
  },
  {
    q: "网站上的内容来源是什么？",
    a: "我们聚合公开渠道的路透、官方公告与网友整理内容，并在每条信息中尽量标注来源性质。所有涉及未经证实的说法，都会在正文里明确提示，不做定性结论。",
  },
  {
    q: "为什么有的爆料后来被删掉了？",
    a: "当相关方给出正式回应，或原始信息被证实存在错误时，我们会更新或撤下对应内容，避免误导。保留的讨论会以「事件进展」的形式继续呈现。",
  },
  {
    q: "可以在看瓜爆料提交自己的线索吗？",
    a: "可以。你可以通过页面底部的联系方式与我们取得联系，并尽量附上可核实的公开信息。我们会先做基础核实，再决定是否发布。",
  },
  {
    q: "热榜的排序依据是什么？",
    a: "热榜综合实时讨论量、刷新频率与互动数据计算，每十五分钟刷新一次。排序仅代表当下热度，不代表我们对事件本身的判断。",
  },
  {
    q: "内容是否有立场倾向？",
    a: "我们尽量保持中立叙述，只呈现已发生的事实与各方回应。评论区观点属于用户个人表达，不代表本站立场。",
  },
];

export const testimonials = [
  {
    name: "阿昼",
    role: "追瓜三年",
    text: "别的平台要翻半天，这里刷新一下就能看到最新进度，时间线整理得特别清楚。",
  },
  {
    name: "小满",
    role: "综艺常驻观众",
    text: "正片没播之前就能看到现场的讨论，等播出再回来看特别有意思。",
  },
  {
    name: "林间",
    role: "影视从业者",
    text: "行业动向那部分挺有价值，排播和改档的信息比很多地方都要快一点。",
  },
  {
    name: "老陈",
    role: "老网民",
    text: "不喜欢夸张的标题，这里比较克制，会说清楚哪些是官方说法，哪些只是传闻。",
  },
];

export const stats = [
  { value: "1,200+", label: "每日更新条目" },
  { value: "15 分钟", label: "热榜刷新间隔" },
  { value: "86 万", label: "日活跃读者" },
  { value: "6 大", label: "主题分类栏目" },
];